/* eslint-disable no-console */
import React, {useEffect, useState} from 'react';

import BlockAccessPage from '../../../../../components/BlockAccess/BlockAccessPage';
import Loader from '../../../../../components/Loader/Loader';
import {API_ENDPOINT_JSON} from '../../../../../config';
import {
  blockAccessTypes,
  blockModelMessages,
  blockModelTypes
} from '../../../../../constants/blockPageConstatnts';
import {APITypeEnum} from '../../../../../services/interface/tableAPIType';
import nzmAPI from '../../../../../services/modules/NZM/NZMAPI';
import {accessModule} from '../../../../../store/companyStore/companyDetailsStore';
import {shouldBlockModuleAccess} from '../../../../../utils/SubscriptionHelper';
import LabelAndCharts from '../../../generalized/utils/LabelAndCharts';

import FinancialWaste from './utils/FinancialWaste';
import OperationalWaste from './utils/OperationalWaste';

const WasteTab: React.FC<{
  selCountry: number | undefined;
  selState: number | undefined;
  selectedYear: string;
  setTabLoading: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({selCountry, selState, selectedYear, setTabLoading}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState<any[]>([]);

  useEffect(() => {
    const filterCountry = selCountry ?? '';
    const filterState = selState ?? '';
    const filterAll = `/${
      filterCountry
        ? filterState
          ? `${filterCountry}/${filterState}`
          : `${filterCountry}`
        : ''
    }`;

    setIsLoading(true);
    setTabLoading(true);
    if (selectedYear) {
      Promise.all([
        nzmAPI(
          APITypeEnum.GET_ALL,
          API_ENDPOINT_JSON.NZM.utility.waste,
          `${selectedYear}${filterAll}`
        )
      ])
        .then(([res1]) => {
          setData(res1);
        })
        .catch(() => {})
        .finally(() => {
          setIsLoading(false);
          setTabLoading(false);
        });
    }
  }, [selectedYear, selCountry, selState]);

  return isLoading ? (
    <Loader topMargin />
  ) : (
    <>
      {shouldBlockModuleAccess(accessModule.scope3) ? (
        <BlockAccessPage
          messageTitle={blockModelMessages.scope.title.genericMessage(
            '3',
            'Waste'
          )}
          messageDescription={blockModelMessages.scope.description.message('3')}
          modelType={blockModelTypes.SCOPE_TOP}
          blockedType={blockAccessTypes.PARTIAL}
        />
      ) : null}
      <LabelAndCharts title="Operational">
        <OperationalWaste data={data} />
      </LabelAndCharts>
      <LabelAndCharts title="Financial">
        <FinancialWaste data={data} />
      </LabelAndCharts>
    </>
  );
};

export default WasteTab;
